<template>
  <div>Refresh</div>
</template>

<script>
export default {
  name: 'Refresh',
  props: {},
  computed: {
    TabList: {
      get () { return this.$store.state.tabs.TabList },
      set (val) { this.$store.commit('updateTabList', val) }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$router.replace(from.path)
      let arr = JSON.parse(JSON.stringify(vm.TabList))
      for (let i in arr) {
        if (arr[i].name === vm.$route.name) {
          // console.log(arr[i].keepAlive)
          arr[i].keepAlive = arr[i].keepAlive.slice(1)
        }
      }
      // 将要刷新的路由keepAlive的值变成空
      vm.TabList = arr
    })
  },
  data () {
    return {
    }
  },
  methods: {
    router () {
      console.log('123')
    }
  }
}
</script>
<style lang="stylus" scoped></style>



// WEBPACK FOOTER //
// src/views/Refresh/Refresh.vue